<template>
  <div class="multi-dimension-efficiency-radar" ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'MultiDimensionEfficiencyRadar',
  inject: ['parentThat'],
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.chart = echarts.init(this.$refs.chartRef);
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart() {
      const option = {
        title: {
          text: '多维效率指标分析',
          left: '10%',
          top: '5%'
        },
        legend: {
          data: ['个人表现', '部门平均'],
          top: '15%'
        },
        radar: {
          indicator: [
            { name: '工作负荷率', max: 10 },
            { name: '按时完成率', max: 10 },
            { name: '任务复杂度', max: 10 },
            { name: '平均处理时长', max: 10 },
            { name: '工单完成数', max: 10 }
          ],
          shape: 'polygon'
        },
        series: [
          {
            name: '个人表现',
            type: 'radar',
            data: [
              {
                value: [10, 10, 10, 8, 9],
                name: '个人表现'
              }
            ],
            itemStyle: {
              color: '#4895ef'
            }
          },
          {
            name: '部门平均',
            type: 'radar',
            data: [
              {
                value: [8, 9, 8, 7, 8],
                name: '部门平均'
              }
            ],
            itemStyle: {
              color: '#00b42a'
            }
          }
        ]
      };
      this.chart.setOption(option);
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>